import React, { useEffect } from 'react';
import Banner from '../Banner';
import SenceCard from '../SenceCard';
import styles from './index.module.scss';

const AnimationA = () => {
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setTimeout(() => {
                const mask1 = document.querySelector(`.screen1-mask`) as HTMLElement;
                const screen1 = document.querySelector(`.screen-1`) as HTMLElement;
                const screen2 = document.querySelector(`.screen-2`) as HTMLElement;
                const ani = AniContainer.create({
                    triggerElement: `#d3a-ani-1`,
                    triggerHook: 0,
                    offset: 0,
                    duration: '360%',
                    onEnter: () => {
                        screen1.classList.add('enter');
                        screen2.classList.add('enter');
                    },
                    onLeave: () => {
                        screen1.classList.remove('enter');
                        screen2.classList.remove('enter');
                    },
                    asyncTimeLine: [0.3, 1.4, 2.4],
                    asyncFromTo: [
                        [mask1, { opacity: 0 }, { opacity: 1 }, 1],
                        [screen1, { opacity: 1 }, { opacity: 0 }, 0.7],
                        [screen2, { opacity: 1 }, { opacity: 0 }, 1.5],
                    ],
                });

                return () => {
                    if (ani) AniContainer.removeScene(ani);
                };
            }, 100);
        }
    }, []);

    return (
        <section id="d3a-ani-1" className={styles.AnimationA}>
            <div className="screen-1">
                <Banner />
                <div className="screen1-mask mask"></div>
            </div>
            <div className="screen-2">
                <SenceCard />
            </div>
        </section>
    );
};

export default AnimationA;
